import { getGTMEventData } from '@tracking/components/transformer';

function genericEventFormatter({
  event,
  action,
  data = {},
  label = '',
  value = '',
  category = '',
}) {
  return getGTMEventData(event, action, data, label, value, category);
}

export default genericEventFormatter;
